import './styles.css';
import CookieSettings from '../CookieSettings';
import PoweredBy from '../PoweredBy';
import { Link } from 'react-router-dom';
import { useEffect, useRef, useState } from 'react';

const Footer = () => {
    const footerRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setIsVisible(true);
                    }
                });
            },
            {
                threshold: 0.1,
                rootMargin: '0px 0px -50px 0px'
            }
        );

        if (footerRef.current) {
            observer.observe(footerRef.current);
        }

        return () => {
            if (footerRef.current) {
                observer.unobserve(footerRef.current);
            }
        };
    }, []);

    return (
        <footer ref={footerRef} className={`site-footer ${isVisible ? 'visible' : ''}`}>
            <div className="footer-content">

                {/* Main Navigation - Institutional */}
                <nav className="footer-nav-main">
                    <div className="footer-nav-column">
                        <h4 className="footer-nav-title">Framework</h4>
                        <Link to="/continuity-os" style={{ fontWeight: 'bold' }}>EternaVaults Continuity OS™</Link>
                        <Link to="/authority-decision-architecture">Authority & Decision Architecture™</Link>
                        <Link to="/continuity-architecture">Continuity Architecture™</Link>
                        <Link to="/continuity-infrastructure">Continuity Infrastructure™</Link>
                        <Link to="/pillars-of-continuity">Pillars of Continuity™</Link>
                        <Link to="/continuity-seismic-map">The Continuity Seismic Map™</Link>
                    </div>

                    <div className="footer-nav-column">
                        <h4 className="footer-nav-title">Solutions</h4>
                        <Link to="/institutional">Institutional Solutions</Link>
                        <Link to="/white-label">Custodied Infrastructure</Link>
                        <Link to="/family-office-pack">Family Office Pack</Link>
                        <Link to="/who-we-work-with">Who We Work With</Link>
                    </div>

                    <div className="footer-nav-column">
                        <h4 className="footer-nav-title">About</h4>
                        <Link to="/why-eternavaults">Why Families Choose</Link>
                        <Link to="/about">About EternaVaults</Link>
                        <Link to="/contact">Contact</Link>
                        <Link to="/security-transparency">Security</Link>
                    </div>
                </nav>

                {/* Utility Links (Patek Philippe Style) */}
                <nav className="footer-utility">
                    <Link to="/glossary" className="footer-utility-link">Glossary</Link>
                    <Link to="/privacy-policy" className="footer-utility-link">Privacy</Link>
                    <Link to="/terms-of-service" className="footer-utility-link">Terms</Link>
                    <Link to="/legal" className="footer-utility-link">Legal & Support</Link>
                    <div className="footer-utility-cookie">
                        <CookieSettings />
                    </div>
                </nav>

                {/* Meta */}
                <div className="footer-meta">
                    <p className="footer-copyright">
                        © {new Date().getFullYear()} EternaVaults. All rights reserved.
                    </p>
                    <p className="footer-trademark">
                        Continuity Architecture™, Temporal Continuity™, Authority & Decision Architecture™,
                        and Pillars of Continuity™ are proprietary frameworks of EternaVaults.
                    </p>
                    <p className="footer-tagline">
                        The World's Only Continuity Operating System for Multi-Generational Stewardship • Independent • Self-Funded • Built for Generational Continuity
                    </p>
                </div>

                {/* Enterprise Infrastructure Trust Markers */}
                <div className="footer-infrastructure">
                    <PoweredBy variant="horizontal" />
                </div>

            </div>
        </footer>
    );
};

export default Footer;